import { Component, OnInit, Input } from '@angular/core';
import { Business} from '../models/business.model';
import { hasTag, loadTags } from '../../util/tag-utils';
import { IConditionalSection } from '../../shared/models/condition-section.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar, MatCheckboxChange } from '@angular/material';
import { Tag } from '../../shared/models/tag.model';
import { BusinessTag } from '../models/business-tag.model';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import { TagService } from '../../shared/services/tag.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-rentals',
  templateUrl: './rentals.component.html',
  styleUrls: ['./rentals.component.scss']
})
export class RentalsComponent implements OnInit, IConditionalSection {
  @Input() business: Business;
  planeAndGliderTags: String[] = [];
  rotorcraftTags: String[] = [];
  equipmentTags: String[] = [];
  simulatorTags: String[] = [];
  hasTag = hasTag;
  editModeSet = false;
  privateTag: Tag;
  isPrivate: boolean;
  isRegionalManager = false;

  constructor(private _toggleService: EditToggleService,
              private _editRentalsCheckboxDialog: MatDialog,
              private _businessManagerService: BusinessManagerService,
              private _tagService: TagService,
              public snackBar: MatSnackBar) {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  async ngOnInit() {
    this.loadAllTags();
    const allTags = await this._tagService.getAllTags();
    this.setPrivate(allTags);
    this.privateTag = this._tagService.findTagByName(allTags, 'Rental::Private');
    this.isRegionalManager = await this._businessManagerService.isRegionalManager()
      && !await this._businessManagerService.userOwnsBusiness(this.business.id);
  }

  loadAllTags() {
    this.planeAndGliderTags = loadTags(this.business.tags, 'Rental::Airplane::', 'Rental::Glider', '');
    this.rotorcraftTags = loadTags(this.business.tags, 'Rental::Rotorcraft::', '', '');
    this.equipmentTags = loadTags(this.business.tags, 'Rental::Equipment::', '', '');
    this.simulatorTags = loadTags(this.business.tags, 'Rental::Simulator::', '', '');
  }

  get hasContent(): boolean {
    return this.planeAndGliderTags.length > 0 || this.rotorcraftTags.length > 0
      || this.equipmentTags.length > 0 || this.simulatorTags.length > 0;
  }

  async setPrivate(allTags: BusinessTag[]) {
    this.privateTag = await this._tagService.findTagByName(allTags, 'Rental::Private');
    this.isPrivate = hasTag(this.business.tags, 'Rental::Private');
  }

  isChecked(tagId: number): boolean {
    const TAGS = this.business.tags;
    for (const tag of TAGS) {
      if (tag.tagId === tagId) {
        return true;
      }
    }
    return false;
  }

  async checkBoxChanged (event: MatCheckboxChange) {
    const ERROR_MSG = 'Unable to save change, please try back later, or call 1-800-USA-AOPA if the error persists.';
    const TAG_ID = +event.source.id;
    const BUSINESS_ID = this.business.id;
    try {
      if (event.source.checked) {
        await this._tagService.postTag(TAG_ID, BUSINESS_ID);
      } else {
        await this._tagService.deleteTag(TAG_ID, BUSINESS_ID);
      }
      const newBusiness = await this._businessManagerService.updateBusiness(this.business);
      Object.assign(this.business, newBusiness);
    } catch (e) {
      this.snackBar.open(ERROR_MSG, 'Error', {
        duration: 6000
      });
      throw e;
    }
  }

  openEditRentalsDialog(group: String[], except: String[], title: string): void {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      business: this.business,
      tagsGroup: group,
      except: except,
      title: title
    };

    dialogConfig.width = '95%';
    const dialogRef = this._editRentalsCheckboxDialog.open(EditTagsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isSuccess) => {
      if (isSuccess) {
        this.loadAllTags();
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
